import getCookie from "../util/cookies";

function adminGetWorker(workerId,success,fail) {
    fetch((process.env.NODE_ENV === 'production' ? "https://api.recipes.bakerstlabs.io/admin/workers/" : "https://dev-api.recipes.bakerstlabs.io/admin/workers/") + workerId,
        {headers: {
                'uid': getCookie("uid"),
                'auth': getCookie("auth")
            }})
        .then(res => res.json())
        .then(
            (result) => {
               success(result.data)
            },
            (error) => {
                fail(error)
            }
        )
    }

export default adminGetWorker
